import React, { useContext, useEffect, useState } from 'react';
import { Badge, Button, Container, Form, Image } from "react-bootstrap"
import { Link, useNavigate } from "react-router-dom"
import FavoriteIcon from "../FavoriteIcon"
import * as Icon from 'react-bootstrap-icons';
import ApiFetch from "../ApiFetch";
import FollowButton from '../FollowButton';
import UserInfoPopup from './UserInfoPopup';
import { useTranslation } from "react-i18next";
import { LanguageCtx, LoginInfo } from '../../App';
import ImageViewPopup from '../ImageViewPopup';
import { rankingBgColor,rankingOpacity } from "./RankingUtil";
import UserMark from '../UserMark';
import VideoViewPopup from '../VideoViewPopup';
import TextViewPopup from '../TextViewPopup';
import EventViewPopup from '../EventViewPopup';
import { imgPath } from '../../service/CommonUtil';
import { LinkContainer } from 'react-router-bootstrap';
import { Chip } from '@mui/material';
import CharacterViewPopup from '../CharacterViewPopup';
import FavoriteIconMui from '@mui/icons-material/Favorite';
import StarIcon from '@mui/icons-material/Star';

const TileNew = (props) => {
    // スタイル定数
    const BADGE_STYLES = {
        position: "absolute",
        zIndex: 2,
        fontSize: "12px",
        padding: "4px 8px",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        gap: "4px"
    };

    const OVERLAY_STYLES = {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%)",
        opacity: 0,
        transition: "opacity 0.3s ease",
        zIndex: 1
    };

    // コンテンツタイプに応じた背景色とアイコンを決定
    const getContentTypeStyle = (contentType) => {
        switch(contentType) {
            case 'text':
            case 'document':
                return {
                    backgroundColor: '#f8f9fa',
                    icon: 'FileText',
                    color: '#495057',
                    gradientOverlay: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                };
            case 'video':
                return {
                    backgroundColor: '#343a40',
                    icon: 'PlayCircleFill',
                    color: '#ffffff',
                    gradientOverlay: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
                };
            case 'event':
                return {
                    backgroundColor: '#fff3cd',
                    icon: 'Calendar',
                    color: '#212529',
                    gradientOverlay: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)'
                };
            case 'image':
            default:
                return {
                    backgroundColor: '#ffffff',
                    icon: 'Image',
                    color: '#000000',
                    gradientOverlay: 'linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.8) 100%)'
                };
        }
    };

    // コンテンツタイプを判定
    const getContentType = (data) => {
        if (props.contentType) return props.contentType;
        if (data.content_type) return data.content_type;
        if (data.contentType) return data.contentType;
        // フォールバック: URLやその他の属性から判定
        if (data.type) return data.type;
        return 'image'; // デフォルト
    };

    async function getUserInfo(userIdOrDisplayId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/"+userIdOrDisplayId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function updateAgeLimitByAdmin(userId,ageLimit){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/ageLimit/"+userId,{ageLimit:ageLimit})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ナビゲート
    const navigate = useNavigate()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    
    // プロップスの取得
    const data = props.data
    const i = props.i || 0
    const dialog = props.dialog
    const observer = props.observer
    const list = props.list || []
    const listName = props.listName || ""
    const from = props.from || ""
    const isLink = props.isLink || false
    const rank = props.rank
    const init = props.init
    const shienLabelDisp = props.shienLabelDisp
    const onClick = props.onClick

    // コンテンツタイプを判定
    const [contentType, setContentType] = useState(getContentType(data));
    const [typeStyle, setTypeStyle] = useState(getContentTypeStyle(contentType));
    
    // 従来のtypeフィールドとの互換性を保持
    const type = data.type || contentType || "image"
    useEffect(() => {
        if(observer !== undefined){
            let lazys = document.querySelectorAll("."+(from === "popup" ? "lazy-popup" : "lazy"))
            let elm = lazys[lazys.length - 1]
            if(elm && elm.dataset.lazy !== "1"){
                observer.observe(elm)
                elm.dataset.lazy = "1"
            }
            document.querySelectorAll("."+(from === "popup" ? "lazy-popup" : "lazy")).forEach(e => {
                if(e.dataset.lazy !== "1"){
                    observer.observe(e)
                    e.dataset.lazy = "1"
                }
            })
        }
    })
    const [displayId,setDisplayId] = useState()
    const [selfIntroduction,setSelfIntroduction] = useState()
    const [follow,setFollow] = useState()
    const [follower,setFollower] = useState()
    const [isFollow,setIsFollow] = useState()
    const [ageLimit,setAgeLimit] = useState("allAges")
    const [showViewPopup,setShowViewPopup] = useState(false)
    const random = Math.random() * 100000
    function clearAllInterval(){
        for (var i = 1; i < 99999; i++)
            window.clearInterval(i)
    }
    const [title,setTitle] = useState("")
    // 言語設定
    const {language,setLanguage} = useContext(LanguageCtx)
    useEffect(() => {
        if(language === "ja"){
            setTitle(data.title)
        } else if(language === "en"){
            if(data.title_en && data.title_en.length > 0){
                setTitle(data.title_en)
            } else {
                setTitle(data.title)
            }
        }
        setContentType(getContentType(data));
        setTypeStyle(getContentTypeStyle(contentType));
    },[language,data])
    return (
        <>
        {type === "character" && showViewPopup ? <CharacterViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
        {type === "image" && showViewPopup ? <ImageViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
        {type === "video" && showViewPopup ? <VideoViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
        {type === "text" && showViewPopup ? <TextViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
        {type === "event" && showViewPopup ? <EventViewPopup groupId={data.group_id} detailId={data.id} switch={setShowViewPopup} i={i} list={props.list} listName={props.listName} /> : ""}
        <div 
            style={{
                position: "relative",
                width: "100%",
                height: "100%",
                borderRadius: "6px",
                //overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease"
            }} 
            className={"event-card mb-0 p-0" + (!(data.age_limit === 1) ? " not-all-ages " : " ") + (data.mute === 1 ? " mute" : "")}
            onMouseOver={() => {
                let elm = document.querySelectorAll("."+from+"thumb-"+i).forEach(elm => {
                    elm.style.opacity = "1"
                    elm.style.transition = "0.3s ease"
                })
                document.querySelectorAll("."+from+"tile-img-"+i).forEach(elm => {
                    elm.style.transform = "scale(1.05)"
                    elm.style.transition = "transform 0.3s ease"
                })
                setInterval(() => {
                    if(type === "video" && data.status >= 4){
                        document.querySelector("."+from+"tile-img-"+i).src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.VIDEO_HOST + imgPath(type) + '/post/t/'+(data.group_id)+"_digest"+ApiFetch.API_THUMB_EXT
                        clearAllInterval()
                    }
                },500)
            }}
            onMouseLeave={() => {
                let elm = document.querySelectorAll("."+from+"thumb-"+i).forEach(elm => {
                    elm.style.opacity = "0"
                    elm.style.transition = "0.3s ease"
                })
                document.querySelectorAll("."+from+"tile-img-"+i).forEach(elm => {
                    elm.style.transform = "scale(1)"
                    elm.style.transition = "transform 0.3s ease"
                })
                if(type === "video" && data.status >= 4){
                    document.querySelector("."+from+"tile-img-"+i).src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.VIDEO_HOST + imgPath(type) + '/post/t/'+(data.group_id)+"_m"+ApiFetch.API_THUMB_EXT
                    clearAllInterval()
                }
            }}
        >
	<div className="cp_ribbon05" style={{display:rank !== undefined ? "block" : "none"}}>
		<div className="cp_ribbon">TOP 3</div>
	</div>
    <div style={{position:"relative",padding:0,overflow:"hidden",width:"100%",height:"100%",objectFit:"cover"}}
    onClick={(e) => {
        if(props.init){
            props.init()
        }
        if(props.isLink){
            navigate("/"+type+"/"+data.group_id)
            return
        }
        if(props.onClick === undefined){
            setShowViewPopup(true)
        } else {
            props.onClick(data,i)
        }
    }}
    >
        {/* バッジ群を整理 - 左上エリア */}
        <div style={{position: "absolute", top: "8px", left: "8px", zIndex: 3, display: "flex", flexDirection: "column", gap: "4px"}}>
            {props.shienLabelDisp !== false && data.limit_div !== undefined && data.limit_div !== "public" && (
                <Chip color="warning" label="支援者限定" style={{fontSize:"12px", fontWeight: "bold"}} size='small' />
            )}
            {data.question_id && data.question_id.length > 0 && (
                <Badge bg="primary" style={{...BADGE_STYLES}}>
                    投票あり
                </Badge>
            )}
            {rank && data.rank !== undefined && (
                <div style={{
                    backgroundColor: rankingBgColor(data.rank),
                    opacity: rankingOpacity(data.rank),
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#FFFFFF",
                    fontWeight: "bold",
                    fontSize: "16px",
                    border: "2px solid white"
                }}>
                    {data.rank}
                </div>
            )}
        </div>

        {/* バッジ群を整理 - 右上エリア */}
        <div style={{position: "absolute", top: "8px", right: "8px", zIndex: 3, display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-end"}}>
            {/* コンテンツタイプバッジ */}
            {contentType !== 'image' && (
                <Badge bg="info" style={{...BADGE_STYLES, fontSize: "10px"}}>
                    {contentType === 'text' || contentType === 'document' ? (
                        <><Icon.FileText style={{fontSize: "12px"}} /> 文書</>
                    ) : contentType === 'video' ? (
                        <><Icon.PlayCircleFill style={{fontSize: "12px"}} /> 動画</>
                    ) : contentType === 'event' ? (
                        <><Icon.Calendar style={{fontSize: "12px"}} /> イベント</>
                    ) : contentType}
                </Badge>
            )}
            
            {rank === undefined && data.character_list !== undefined && data.character_list.length > 0 && (
                data.character_list.filter(d => d.user_id === data.user_id).length === data.character_list.length ? 
                <Chip label="公式" style={{fontSize:"12px", backgroundColor:"#ff69b4", color: "white", fontWeight: "bold"}} size='small' /> :
                <Chip label={<><FavoriteIconMui style={{color:"red", fontSize: "14px"}} /> ファンアート</>} style={{fontSize:"12px", backgroundColor:"#ff69b4", color: "white", fontWeight: "bold"}} size='small' />
            )}
            {data.age_limit === 2 && <Badge bg="secondary" style={BADGE_STYLES}>PG-12</Badge>}
            {data.age_limit === 3 && <Badge bg="secondary" style={BADGE_STYLES}>R-15</Badge>}
            {data.age_limit === 4 && <Badge bg="warning" style={BADGE_STYLES}>R-18</Badge>}
            {data.age_limit === 5 && <Badge bg="danger" style={BADGE_STYLES}>R-18G</Badge>}
        </div>

        {/* バッジ群を整理 - 左下エリア */}
        <div style={{position: "absolute", bottom: "12px", left: "8px", zIndex: 3, display: "flex", gap: "6px", alignItems: "center"}}>
            {data.img_count > 1 && (
                <Badge bg="secondary" style={{...BADGE_STYLES, backgroundColor:"rgba(0,0,0,0.7)", color: "white"}}>
                    <Icon.CollectionFill style={{fontSize: "14px"}} /> {data.img_count}
                </Badge>
            )}
            {data.find_prompt !== undefined && data.find_prompt === 1 && (
                <Badge bg="secondary" style={{...BADGE_STYLES, backgroundColor:"rgba(0,0,0,0.7)", color: "white"}}>
                    <Icon.PSquareFill style={{fontSize: "14px"}} />
                </Badge>
            )}
            {(data.count !== undefined || data.pv_count !== undefined) && (
                <Badge bg="secondary" style={{...BADGE_STYLES, backgroundColor:"rgba(0,0,0,0.7)", color: "white"}} className='d-none'>
                    <Icon.EyeFill style={{fontSize: "14px"}} /> {data.count !== undefined ? data.count : data.pv_count}
                </Badge>
            )}
        </div>
        {/* メイン画像/コンテンツ表示エリア */}
        {contentType === 'text' || contentType === 'document' ? (
            // 文書コンテンツの場合
            <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: typeStyle.gradientOverlay,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                textAlign: "center",
                padding: "16px"
            }}>
                <div style={{width:"100%",height:"50%"}}>
                <img style={{objectFit:"cover",width:"100%",height:"100%"}} src={(data.limit_div !== "public" && data.plan_access === 0 || data.unit_amount > 0 && data.is_purchased === 0) ? 
                        (ApiFetch.API_PROTOCOL+'//'+(contentType === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST)+imgPath(contentType)+'/post/t/'+(data.group_id)+"_in"+ApiFetch.API_THUMB_EXT) : 
                        ApiFetch.API_PROTOCOL+'//'+(contentType === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST)+imgPath(contentType)+'/post/t/'+(contentType === "video" ? data.group_id : data.id)+"_m"+ApiFetch.API_THUMB_EXT
                } />
                </div>
                <h6 style={{color: "white", fontWeight: "bold", marginBottom: "8px", overflow: "hidden", textOverflow: "ellipsis"}}>
                    {title || data.title || '文書'}
                </h6>
                <p style={{color: "rgba(255,255,255,0.9)", fontSize: "12px", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical"}}>
                    {data.description || data.content || '文書の内容が表示されます'}
                </p>
            </div>
        ) : contentType === 'event' ? (
            // イベントコンテンツの場合
            <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: typeStyle.gradientOverlay,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                color: "#2c3e50",
                textAlign: "center",
                padding: "16px"
            }}>
                <div style={{width:"100%",height:"50%"}}>
                <img style={{objectFit:"cover",width:"100%",height:"100%"}} src={(data.limit_div !== "public" && data.plan_access === 0 || data.unit_amount > 0 && data.is_purchased === 0) ? 
                        (ApiFetch.API_PROTOCOL+'//'+(type === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST)+imgPath(type)+'/post/t/'+(data.group_id)+"_in"+ApiFetch.API_THUMB_EXT) : 
                        ApiFetch.API_PROTOCOL+'//'+(type === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST)+imgPath(type)+'/post/t/'+(data.id)+"_m"+ApiFetch.API_THUMB_EXT
                } />
                </div>
                <h6 style={{color: "#2c3e50", fontWeight: "bold", marginBottom: "8px", overflow: "hidden", textOverflow: "ellipsis"}}>
                    {title || data.title || 'イベント'}
                </h6>
                <p style={{color: "#34495e", fontSize: "12px", marginBottom: "8px"}}>
                    {data.from_datetime ? new Date(data.from_datetime).toLocaleDateString('ja-JP') : '日時未定'}
                </p>
                <p style={{color: "#34495e", fontSize: "11px", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical"}}>
                    {data.description || 'イベントの詳細が表示されます'}
                </p>
            </div>
        ) : (
            // 画像・動画コンテンツの場合（既存の実装）
            <>
                <img 
                    data-no={i} 
                    loading="lazy" 
                    src={(data.limit_div !== "public" && data.plan_access === 0 || data.unit_amount > 0 && data.is_purchased === 0) ? 
                        (ApiFetch.API_PROTOCOL+'//'+(contentType === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST)+imgPath(contentType)+'/post/t/'+(data.group_id)+"_in"+ApiFetch.API_THUMB_EXT) : 
                        ApiFetch.API_PROTOCOL+'//'+(contentType === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST)+imgPath(contentType)+'/post/t/'+(contentType === "video" ? data.group_id : data.id)+"_m"+ApiFetch.API_THUMB_EXT
                    }
                    style={{
                        filter:(
                            loginInfo.pg12_display_flag === 2 && data.age_limit === 2
                            || loginInfo.r15_display_flag === 2 && data.age_limit === 3
                            || loginInfo.r18_display_flag === 2 && data.age_limit === 4
                            || loginInfo.r18g_display_flag === 2 && data.age_limit === 5
                        ) || data.age_limit === 5 || data.sensitive_flag === 1 || data.sensitive_flag === 2 ? "blur(20px)" : "none",
                        objectFit:"cover",
                        width:"100%",
                        height:"100%",
                        transition: "transform 0.3s ease"
                    }} 
                    className={"p-0 "+(from==="popup"?"lazy-popup":"lazy")+" "+from+"tile-img-"+i}
                    alt={title || "Content image"}
                />
                {/* 動画の場合の再生アイコン */}
                {contentType === 'video' && (
                    <div style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2,
                        color: "white",
                        fontSize: "48px",
                        textShadow: "2px 2px 4px rgba(0,0,0,0.8)"
                    }}>
                        <Icon.PlayCircleFill />
                    </div>
                )}
            </>
        )}
        
        {/* ホバー時のオーバーレイとコンテンツ */}
        <div className={"p-0 "+from+"thumb-"+i} style={{...OVERLAY_STYLES}}>
            {/* グラデーションオーバーレイ */}
            <div style={{
                position:"absolute",
                top:0,
                left:0,
                right:0,
                bottom:0,
                background: "linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.8) 100%)",
                zIndex:1
            }} />
            
            {/* タイトル */}
            <div style={{
                position:"absolute",
                zIndex:3,
                bottom:"60px",
                left:"12px",
                right:"12px",
                fontWeight:"bold",
                fontSize:"15px",
                color:"#FFFFFF",
                textShadow:"2px 2px 4px rgba(0,0,0,0.8)",
                overflow:"hidden",
                textOverflow:"ellipsis",
                whiteSpace:"nowrap"
            }}>
                <span 
                    onClick={(e) => {
                        if(props.isLink){
                            navigate("/"+type+"/"+data.group_id)
                            return
                        }
                        if(props.onClick === undefined){
                            setShowViewPopup(true)
                        } else {
                            props.onClick(data,i)
                        }
                    }} 
                    style={{color:"#FFFFFF",textDecoration:"none",cursor:"pointer"}}
                >
                    {title}
                </span>
            </div>
            
            {/* ユーザー情報 */}
            <div style={{
                position:"absolute",
                zIndex:3,
                bottom:"12px",
                left:"12px",
                right:"60px",
                overflow:"hidden"
            }}>
                <Link 
                    to={"/user/"+(data.display_id !== undefined && data.display_id !== "" ? data.display_id : data.user_id)} 
                    style={{
                        color:"#FFFFFF",
                        fontWeight:"bold",
                        textDecoration:"none",
                        cursor:"pointer",
                        display:"flex",
                        alignItems:"center",
                        gap:"8px",
                        textShadow:"2px 2px 4px rgba(0,0,0,0.8)"
                    }}
                    onMouseOver={(e) => {
                        if(data.user_id !== "anonymous")
                        setInterval(() => {
                            getUserInfo(data.user_id).then(r => {
                                let elm = document.getElementById("sub-"+random)
                                if(elm){
                                    document.getElementById("sub-"+random).style.display = "block"
                                }
                                setDisplayId(r.display_id)
                                setSelfIntroduction(r.self_introduction)
                                setFollow(r.follow)
                                setFollower(r.follower)
                                setIsFollow(r.isFollow)
                                clearAllInterval()
                            })
                        },500)
                    }}
                    onMouseLeave={() => {
                        clearAllInterval()
                    }}
                >
                    <Image 
                        loading="lazy" 
                        src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/profile/'+(data.user_id)+'_s.jpg?'+data.hash} 
                        style={{
                            borderRadius:"50%",
                            display:data.user_id ? "inline" : "none",
                            border:"2px solid white"
                        }} 
                        width="28px" 
                        height="28px" 
                    />
                    <div style={{overflow:"hidden"}}>
                        <ruby style={{fontSize:"14px"}}> 
                            {data.user_name && data.user_name.length > 10 ? data.user_name.substr(0,10) + "…" : data.user_name} 
                            <rp>(</rp><rt style={{fontSize:"10px"}}>{data.user_name_kana && data.user_name_kana.length > 10 ? data.user_name_kana.substr(0,10) + "…" : data.user_name_kana}</rt><rp>)</rp> 
                        </ruby>
                        <UserMark 
                            sms_auth={data.sms_auth} 
                            role={data.role} 
                            plan={data.plan} 
                            beginner={data.beginner} 
                            moderator_badge_display_flag={data.moderator_badge_display_flag} 
                            dialog={dialog} 
                        />
                        {data.isFollowed === 1 && (
                            <span style={{
                                fontSize:"10px",
                                color:"#333",
                                backgroundColor:"rgba(255,255,255,0.9)",
                                borderRadius:"4px",
                                padding:"2px 4px",
                                marginLeft:"4px"
                            }}>
                                フォローされています
                            </span>
                        )}
                    </div>
                </Link>
            </div>
            
            {/* クリック可能エリア */}
            <div 
                style={{
                    position:"absolute",
                    top:0,
                    left:0,
                    right:0,
                    bottom:0,
                    zIndex:2,
                    cursor:"pointer"
                }}
                onClick={(e) => {
                    e.stopPropagation()
                    if(props.isLink){
                        navigate("/"+type+"/"+data.group_id)
                        return
                    }
                    if(props.onClick === undefined){
                        setShowViewPopup(true)
                    } else {
                        props.onClick(data,i)
                    }
                }}
            />
        </div>

        {/* お気に入りアイコン - 右下 */}
        <div style={{position: "absolute", bottom: "8px", right: "8px", zIndex: 3}}>
            <FavoriteIcon 
                style={{
                    fontSize:"20px",
                    cursor:"pointer",
                    filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.8))",
                    display: data.favorite !== undefined ? "inline" : "none"
                }} 
                type={type} 
                id={data.group_id} 
                favorite={data.favorite} 
                dialog={dialog} 
                count={data.favorite_count} 
            />
        </div>
        </div>

        {/* 管理者用年齢制限設定 */}
        {false && loginInfo.is_admin && (
            <div style={{position:"absolute", top:"30px", left:"8px", zIndex:4, backgroundColor:"rgba(255,255,255,0.95)", padding:"8px", borderRadius:"8px"}}>
                <Form.Select 
                    className="mb-2" 
                    value={ageLimit}
                    style={{fontSize:"12px"}}
                    onChange={(e) => setAgeLimit(e.currentTarget.value)}
                >
                    <option value="年齢制限" disabled>【年齢制限】</option>
                    <option value="allAges">全年齢(性表現なし)</option>
                    <option value="r15">全年齢(R-15)</option>
                    <option value="r18">R-18</option>
                    <option value="r18g">R-18G</option>
                </Form.Select>
                <Button 
                    size="sm"
                    onClick={() => {
                        updateAgeLimitByAdmin(data.group_id,ageLimit).then(r => {
                            if(r.result){
                                dialog("確認","年齢制限を「"+r.data.ageLimitReturn+"」に更新しました。")
                            } else {
                                dialog("エラー",r.errors)
                            }
                        })
                    }}
                >
                    更新(管理者権限)
                </Button>
            </div>
        )}
        
        <UserInfoPopup 
            data={data} 
            displayId={displayId} 
            selfIntroduction={selfIntroduction} 
            isFollow={isFollow} 
            follow={follow} 
            follower={follower} 
            random={random} 
            dialog={dialog} 
        />
    </div>
    </>
    )
}

export default TileNew